import React, { Component } from "react";
import { Button, ColumnLayout, Input } from "@amzn/awsui-components-react";

export default class FilterComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            metadataKey: "",
            metadataValue: ""
        };

        this.handleInputMetadataKeyChange = this.handleInputMetadataKeyChange.bind(this);
        this.handleInputMetadataValueChange = this.handleInputMetadataValueChange.bind(this);
    }

    handleInputMetadataKeyChange = (event) => {
        this.setState({ metadataKey: event.detail.value });
    };

    handleInputMetadataValueChange = (event) => {
        this.setState({ metadataValue: event.detail.value });
    };

    handleReset = () => {
        this.setState({ metadataKey: "", metadataValue: "" });
        if (this.props && this.props.handleClearFilter) {
            this.props.handleClearFilter();
        }
    }

    render() {
        const {
            metadataKey,
            metadataValue
        } = this.state;
        return (
            <ColumnLayout columns={2}>
                <Input
                    onChange={this.handleInputMetadataKeyChange}
                    value={metadataKey}
                    placeholder="enter a metadata key to filter by"
                />
                <Input
                    onChange={this.handleInputMetadataValueChange}
                    value={metadataValue}
                    placeholder="enter a metadata value to filter by"
                />
                <Button onClick={() => this.props.handleApplyFilter(metadataKey, metadataValue)}>
                    FILTER
                </Button>
                <Button onClick={() => this.handleReset()}>
                    RESET
                </Button>
            </ColumnLayout>
        );
    }
}